import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { setHostUserPassword } from '../../api/host.api';

// image
import logo from "../../images/logo_black.png";
import loginbg from "../../images/somadome-spaceship.webp";

function SetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('hostDetails') || localStorage.getItem('authToken');
    if (token) {
      // User is logged in, redirect to dashboard
      navigate('/host/dashboard');
    }
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!password || !confirmPassword) {
      setError('Both fields are required');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    try {
      setLoading(true);
      const response = await setHostUserPassword({
        token,
        email,
        password
      });
      setSuccess(true);
      setTimeout(() => {
        navigate('/host/login');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };

  if (!token || !email) {
    return (
      <div className="container text-center py-5">
        <h2 className="text-danger">Invalid Link</h2>
        <p>This password setup link is invalid or has expired.</p>
      </div>
    );
  }

  return (
    <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="login-aside text-center d-flex flex-column flex-row-auto">
        <div className="d-flex flex-column-auto flex-column">
          <div className="text-center mb-4 pt-5">
            <img src={logo} alt="" style={{ width: "200px" }} />
          </div>
          <h3 className="mb-2">Create Your Password</h3>
          <p>Please set a secure password for your account.</p>
        </div>
        <div className="aside-image" style={{ backgroundImage: "url(" + loginbg + ")" }}></div>
      </div>
      <div className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div className="d-flex justify-content-center h-100 align-items-center">
          <div className="authincation-content style-2">
            <div className="row no-gutters">
              <div className="col-xl-12 tab-content">
                <div id="sign-up" className="auth-form form-validation">
                  {error && (
                    <div className='bg-red-300 text-red-900 border border-red-900 p-2 my-2 rounded'>
                      {error}
                    </div>
                  )}
                  {success && (
                    <div className='bg-green-300 text-green-900 border border-green-900 p-2 my-2 rounded'>
                      Password set successfully! Redirecting to login...
                    </div>
                  )}
                  <form onSubmit={onSubmit} className="form-validate">
                    <h3 className="text-center mb-4 text-black">Set Your Password</h3>
                    <div className="form-group mb-3">
                      <label className="mb-1"><strong>New Password</strong></label>
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your new password"
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1"><strong>Confirm Password</strong></label>
                      <input
                        type="password"
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm your password"
                      />
                    </div>
                    <div className="text-center form-group mt-4">
                      <button type="submit" className="btn btn-primary btn-block" disabled={loading || success}>
                        {loading ? 'Processing...' : 'Set Password'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SetPassword;
